import { loginRequestConfig } from "../../../config/authConfig";
import { post, get } from "../../../services/request";

// export const login = (data) => post("User/UserSSOSignIn", data);
export const login = (data) => post("Coaxion/SignIn/SSOLogin", data);
export const customLogin = (data) => post("Coaxion/SignIn/CustomSignIn", data);
export const verifyMfa = (data) => post("Coaxion/SignIn/VerifyMfa", data);
export const oktaLogin = (data) => post("Coaxion/SignIn/OktaLogin", data);
export const googleLogin = (data) => post("Coaxion/SignIn/GoogleLogin", data);
export const checkLoginType = (email) =>
  get(`Coaxion/SignIn/CheckLoginType?email=${encodeURIComponent(email)}`);
export const samlChallenge = () => get("Coaxion/SignIn/SamlChallenge");
export const forgotPassword = (data) => post("Coaxion/SignIn/ForgotPassword", data);
export const resetPassword = (data) => post("Coaxion/SignIn/ResetPassword", data);
// Provider dark mode preference ({ IsDarkMode: bool }); the response carries a re-issued token with the new IsDarkMode claim.
export const saveThemePreference = (data) => post("Coaxion/User/SaveThemePreference", data);
export const getEmailByUserId = (uid) =>
  get(`Coaxion/SignIn/GetEmailByUserId?uid=${encodeURIComponent(uid)}`);

export const handleMicrosoftLogin = async ({ instance, accounts }) => {
  try {
    if (accounts.length > 0) {
      const silentRequest = {
        ...loginRequestConfig,
        account: accounts[0],
      };
      const response = await instance.acquireTokenSilent(silentRequest);
      return response;
    } else {
      const response = await instance.loginPopup(loginRequestConfig);
      return response;
    }
  } catch (error) {
    console.error("Microsoft login failed:", error);
  }
};
